







































































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  IClientTemplatesSlotsData,
  IClientTemplatesSlotsMethods
} from "@/models/providers/templates";

@Component({
  components: {
    "slot-list-item": () =>
      import("@/components/app/admin/clientTemplates/slotListItem.vue")
  }
})
export default class ClientTemplatesSlotsListing extends Vue {
  // Inject
  @Inject({ from: "clientTemplateSlotsProvider" })
  public clientTemplateSlotsProvider!: () => IClientTemplatesSlotsData;

  @Inject({ from: "clientTemplateSlotsProviderMethods" })
  public $slotsMethods!: IClientTemplatesSlotsMethods;

  // Computed
  public get $slotsData() {
    return this.clientTemplateSlotsProvider();
  }

  public get table() {
    return this.$slotsData.table;
  }

  public get isLoading() {
    return this.$slotsData.isLoading;
  }

  public get skeletonSize() {
    return (
      this.$slotsData.table.total ||
      (this.$store.getters["ui/isMobile"] ? 2 : 6)
    );
  }
}
